import * as React from 'react';
import { FC } from 'react';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import { useTranslate } from 'react-admin';
import { Typography } from '@material-ui/core';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: number;
    title?: string;
    subtitle?: string;
}

const NbCourses: FC<Props> = ({ value, title, subtitle }) => {
    const translate = useTranslate();
    return (
        <CardWithIcon
            to="/courses"
            icon={DirectionsCarIcon}
            title={translate(title)}
            subtitle={value ? `${value} ` : '--'}
            children={
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '10px',
                    }}
                >
                    <Typography color="textSecondary">
                        {translate(subtitle)}
                    </Typography>
                </div>
            }
        />
    );
};

export default NbCourses;
